var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5C8.89543 5 8 5.89543 8 7V10H10.4009C8.92418 11.3697 8 13.3269 8 15.5C8 17.6731 8.92418 19.6303 10.4009 21H5C3.89543 21 3 20.1046 3 19V12C3 10.8954 3.89543 10 5 10H6V7C6 4.79086 7.79086 3 10 3C12.2091 3 14 4.79086 14 7V8.15003C13.3138 8.28931 12.6617 8.52227 12.0575 8.83498C12.0203 8.73026 12 8.61749 12 8.5V7C12 5.89543 11.1046 5 10 5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15.5C10 12.4624 12.4624 10 15.5 10C18.5376 10 21 12.4624 21 15.5C21 18.5376 18.5376 21 15.5 21C12.4624 21 10 18.5376 10 15.5ZM16.5 14C16.5 13.4477 16.0523 13 15.5 13C14.9477 13 14.5 13.4477 14.5 14V15.5C14.5 15.7652 14.6054 16.0196 14.7929 16.2071L15.7929 17.2071C16.1834 17.5976 16.8166 17.5976 17.2071 17.2071C17.5976 16.8166 17.5976 16.1834 17.2071 15.7929L16.5 15.0858V14Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockTime);
export default __webpack_public_path__ + "static/media/lockTime.069f93eb1720a3ae8cba7cc190f5c557.svg";
export { ForwardRef as ReactComponent };